import {
  REQUEST_CART_ITEMS,
  RECEIVE_CART_ITEMS,
  CREATE_CART_ITEM,
  DELETE_CART_ITEM,
  INVALIDATE_CART_ITEMS
} from 'constants/ActionTypes'

const cartItemsReducer = (state = { isFetchingCartItem: false, didInvalidateCartItem: false, cartItems: [], lastUpdatedCartItem: null }, action) => {
  switch (action.type) {
    case INVALIDATE_CART_ITEMS:
      return Object.assign({}, state, {
        didInvalidateCartItem: true
      })
    case REQUEST_CART_ITEMS:
      return Object.assign({}, state, {
        isFetchingCartItem: true,
        didInvalidateCartItem: false
      })
    case RECEIVE_CART_ITEMS:
      return Object.assign({}, state, {
        isFetchingCartItem: false,
        didInvalidateCartItem: false,
        cartItems: action.cartItems,
        lastUpdatedCartItem: action.receivedAt
      })
    case CREATE_CART_ITEM:
      return Object.assign({}, state, {
        cartItems: [
          ...state.cartItems,
          {
            listing_id: action.listingID
          }
        ]
      })
    case DELETE_CART_ITEM:
      return Object.assign({}, state, {
        cartItems: state.cartItems.filter((item) => item.id !== action.cartID)
      })
    default:
      return state
  }
}

export default cartItemsReducer
